module.exports = __webpack_public_path__ + "static/img/team_plus_icon.f13d526.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/team_plus_icon.png
// module id = nZ2J
// module chunks = 1